import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultEnum } from "../../types.client";
import { CoaxialFieldStrengthMeasure } from "../../../models/schemas/measures/fieldStrength.schema";
import { COAXIAL_FIELD_STRENGTH_THRESHOLDS } from "../../constants/frequencyThresholds";

/**
 * 동축케이블 전계강도 컨트롤러
 * 주파수대역별 상한:
 * - 54-216MHz: 20 μV/m
 * - 216-400MHz: 15 μV/m
 * - 400MHz+: 10 μV/m
 * 기준: 측정값이 상한 이하이면 양호 (낮을수록 좋음)
 */
export class CoaxialFieldStrengthController extends MeasureController<CoaxialFieldStrengthMeasure> {
  protected getDefaultData(): CoaxialFieldStrengthMeasure {
    return {
      standardValue: 0,
      measuredValue: 0,
      unit: "μV/m",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
      createdAt: null,
    };
  }

  protected judge(): JudgmentResult {
    const { measuredValue = 0 } = this.data;
    const frequencyBand = this.config.extra?.frequencyBand;

    if (!frequencyBand) {
      throw new Error("주파수대역(config.extra.frequencyBand)이 설정되지 않았습니다.");
    }

    const threshold =
      COAXIAL_FIELD_STRENGTH_THRESHOLDS[
        frequencyBand as keyof typeof COAXIAL_FIELD_STRENGTH_THRESHOLDS
      ];

    if (threshold === undefined) {
      throw new Error(`유효하지 않은 주파수대역: ${frequencyBand}`);
    }

    const result = measuredValue <= threshold ? JudgmentResultEnum.GOOD : JudgmentResultEnum.BAD;
    const discussion = this.generateDiscussion(result);

    return { result, discussion };
  }

  protected generateDiscussion(result: "GOOD" | "CAUTION" | "BAD" | "NA"): string {
    const { measuredValue = 0 } = this.data;
    const frequencyBand = this.config.extra?.frequencyBand || "";
    const threshold =
      COAXIAL_FIELD_STRENGTH_THRESHOLDS[
        frequencyBand as keyof typeof COAXIAL_FIELD_STRENGTH_THRESHOLDS
      ];

    if (threshold === undefined) {
      return `주파수대역 정보 없음`;
    }

    if (result === JudgmentResultEnum.GOOD) {
      return `측정값 ${measuredValue}μV/m, 대역 ${frequencyBand} 기준 ${threshold}μV/m 이하로 양호`;
    } else {
      return `측정값 ${measuredValue}μV/m, 대역 ${frequencyBand} 기준 ${threshold}μV/m 초과로 불량`;
    }
  }
}
